import axios from "axios";

const API_URL =
  process.env.REACT_APP_ACCOUNT_SERVICE_API_HOST || "http://localhost:3000";

const api = axios.create({
  baseURL: API_URL,
});

export async function login(email, password) {
  const { data } = await api.post(
    "/auth/login",
    { email, password },
    { withCredentials: true }
  );
  return data;
}

export async function logout() {
  try {
    await api.post("/auth/logout", {}, { withCredentials: true });
  } catch (e) {
    console.warn("Logout request failed", e);
  }
}

export async function forgotPassword(email) {
  return api.post("/auth/forgot-password", { email }, { withCredentials: true });
}

export async function resetPassword(email, code, password) {
  return api.post("/auth/reset-password", { email, code, password }, { withCredentials: true });
}

export async function changePassword(oldPassword, newPassword) {
  return api.post("/auth/change-password", { oldPassword, newPassword }, { withCredentials: true });
}

export async function authorize() {
  const { data } = await api.get("/auth/me", { withCredentials: true });
  return data;
}
